module.exports = __webpack_public_path__ + "static/media/campy.0d78ee62.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/campy.webp
// module id = 245
// module chunks = 0